import { createPayload } from './common'

export default (name, data) => {
  const initialState = createPayload(data || null)

  return (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
      case `${name}_SET`:
        return payload
      case `${name}_CLEAR`:
        return createPayload(null)
      default:
        return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/utils/syncReducer.js